var History = require('../../../core/history/history');

module.exports = {
  get: function (attributeChain) {
    if (attributeChain == 'version') {
      return History.getVersion(arguments[1]);
    }

    if (attributeChain == 'current') {
      return History.getCurrentId();
    }
  }
};
